

function scrollTo(){
	if (!$('.js-scroll-go').length) {
		return false;
	}

	$('.js-scroll-go').on('click', function () {
		var scroll_el = $(this).attr('href');
		if ($(scroll_el).length !== 0) {
			$('html, body').animate({ scrollTop: $(scroll_el).offset().top }, 500);
		}
		return false;
	});
	
}



/**
 * Инит модуля
 */
function init() {
	scrollTo();
}

module.exports = {
	init,
};
